module.exports = __webpack_public_path__ + "images/55aed7e0cbb225f115a186361f7c629f.png";